import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { trackAppEvent } from "../lib/appTelemetry";

const API = process.env.REACT_APP_BACKEND_URL + "/api";
const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "";

/**
 * Tracks every route change: pings GA4 (if configured) and our own backend
 * `/api/analytics/track` for the admin dashboard.
 */
export default function PageViewTracker() {
  const location = useLocation();
  useEffect(() => {
    const route = location.pathname.split("/")[1] || "home";
    const screen = ({ dashboard: "profile", auth: "auth", kundli: "kundli", chat: "chat", matching: "matching", consultation: "consultation", blog: "blog", horoscope: "horoscope", livechat: "livechat" })[route] || "home";
    if (!["admin", "mobile"].includes(route)) trackAppEvent("screen_view", screen);
    const path = location.pathname;
    // GA4
    if (GA_ID && typeof window.gtag === "function") {
      window.gtag("event", "page_view", { page_path: path, page_location: window.location.href });
    }
    // Our own backend
    const sid = (() => {
      let s = localStorage.getItem("af_sid");
      if (!s) { s = (Math.random().toString(36).slice(2) + Date.now().toString(36)); localStorage.setItem("af_sid", s); }
      return s;
    })();
    const isReturning = localStorage.getItem("af_seen") === "1";
    if (!isReturning) localStorage.setItem("af_seen", "1");
    axios.post(`${API}/analytics/track`, {
      path,
      referrer: document.referrer || "",
      session_id: sid,
      is_returning: isReturning,
    }).catch(() => {});
  }, [location]);
  return null;
}
